import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      900: "#6027ad",
      600: "#D9CBF9",
      100: "#FCFBFD",
    },
  },
  fonts: {
    heading: "Poppins",
    body: "Poppins",
  },
});

export default theme;
